import { Text, useIsNarrowViewport } from '@iconik-io/uad';

import { NoCommentsIcon } from './icons/no_comments_icon';
import { NoTranscriptionsIcon } from './icons/no_transcriptions_icon';

import styles from './empty_state.module.css';

type EmptyStateProps = {
  type:
    | 'transcriptions'
    | 'comments'
    | 'comments_filtered'
    | 'comments_older_version';
};

export function EmptyState({ type }: EmptyStateProps) {
  const isMobile = useIsNarrowViewport();

  return (
    <div className={styles.empty_state_wrapper}>
      {type === 'transcriptions' ? (
        <>
          {!isMobile ? <NoTranscriptionsIcon /> : null}
          <Text>This asset has not been transcribed</Text>
        </>
      ) : null}
      {type === 'comments' ? (
        <>
          {!isMobile ? <NoCommentsIcon /> : null}
          <Text>Comments will show up here</Text>
        </>
      ) : null}
      {type === 'comments_filtered' ? (
        <>
          {!isMobile ? <NoCommentsIcon /> : null}
          <Text>No comments matching your filters have been found</Text>
        </>
      ) : null}
      {type === 'comments_older_version' ? (
        <>
          {!isMobile ? <NoCommentsIcon /> : null}
          <Text>No comments made on this version</Text>
        </>
      ) : null}
    </div>
  );
}
